import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSearchLine = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "currentColor",
	id: "svg1",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { id: "defs1" }), /* @__PURE__ */ _jsx("path", {
		id: "path2",
		d: "M 11.738281,2 C 6.3682866,2 2,6.3682866 2,11.738281 c 0,5.369995 4.3682866,9.738281 9.738281,9.738281 2.296698,0 4.411327,-0.798013 6.078125,-2.132812 l 3.167969,3.158203 c 0.147,0.146 0.338297,0.220703 0.529297,0.220703 0.192,0 0.38525,-0.07466 0.53125,-0.222656 0.293,-0.293 0.293,-0.765594 0,-1.058594 l -3.13086,-3.125 c 1.591099,-1.734198 2.5625,-4.044627 2.5625,-6.578125 C 21.476562,6.3682866 17.108276,2 11.738281,2 Z m 0,1.5 c 4.541996,0 8.238281,3.6952858 8.238281,8.238281 0,4.542996 -3.696285,8.238281 -8.238281,8.238281 C 7.1952858,19.976563 3.5,16.281277 3.5,11.738281 3.5,7.1952858 7.1952858,3.5 11.738281,3.5 Z"
	})]
});
export default SvgSearchLine;
